import React, { useState } from "react";
import { motion } from "framer-motion";
import "./style.css";
const UpslidingText = ({
  text = "",
  textSize = "text-5xl",
  noUnderline = null,
  marginTop = null,
  maxHeight = "max-h-12",
  textCenter = null,
  color = null,
  onClick = () => {},
}) => {
  const [hover, setHover] = useState(false);
  return (
    <>
      <div
        className={`${
          marginTop && "mt-24 md:mt-48"
        } ${maxHeight}  overflow-hidden w-[fit-content] ${
          textCenter && "mx-auto"
        } relative sliding-text-container cursor-pointer`}
        onMouseOver={(e) => {
          setHover(true);
        }}
        onMouseOut={(e) => {
          setHover(false);
        }}
        onClick={onClick}
      >
        {!noUnderline && (
          <div className='text-underline-div bg-dark dark:bg-light'></div>
        )}
        <div className='flex justify-center'>
          {text.split("").map((letter, index) => {
            if (letter === " ") {
              return (
                <motion.p
                  initial={{ y: 0 }}
                  animate={hover ? { y: "-100%" } : { y: 0 }}
                  transition={{
                    type: "tween",
                    duration: 0.5,
                    delay: 0.05 * index,
                  }}
                  className={`${textSize} font-bold ${color ? color : ""}`}
                >
                  &nbsp;
                </motion.p>
              );
            }
            return (
              <motion.p
                initial={{ y: 0 }}
                animate={hover ? { y: "-100%" } : { y: 0 }}
                transition={{
                  type: "tween",
                  duration: 0.5,
                  delay: 0.05 * index,
                }}
                className={`${textSize} font-bold ${color ? color : ""}`}
              >
                {letter}
              </motion.p>
            );
          })}
        </div>
        <div className='flex justify-center'>
          {text.split("").map((letter, index) => {
            if (letter === " ") {
              return (
                <motion.p
                  initial={{ y: 0 }}
                  animate={hover ? { y: "-100%" } : { y: 0 }}
                  transition={{
                    type: "tween",
                    duration: 0.5,
                    delay: 0.05 * index,
                  }}
                  className={`${textSize} font-bold ${color ? color : ""}`}
                >
                  &nbsp;
                </motion.p>
              );
            }
            return (
              <motion.p
                initial={{ y: 0 }}
                animate={hover ? { y: "-100%" } : { y: 0 }}
                transition={{
                  type: "tween",
                  duration: 0.5,
                  delay: 0.05 * index,
                }}
                className={`${textSize} font-bold ${color ? color : ""}`}
              >
                {letter}
              </motion.p>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default UpslidingText;
